// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__KSovW","moreBtn":"styles_moreBtn__pLDFU"};